import gql from 'graphql-tag';
import { findIndex, isEmpty } from 'lodash';
import apollo from 'src/features/apolloSecure';
import { parseConfig } from 'api/getChannels';
import i18n from 'src/features/i18n';
import toast from 'src/utils/toast';
import consts from 'src/utils/consts';

const query = gql`
query GetChannelsPagination($page: Int, $pageSize: Int) {
  channelsPagination(page: $page, pageSize: $pageSize) {
    channels {
      id
      name
      type
      priority
      identifier
      group {
        id
        name
        description
      }
      teams {
        id
        name
      }
      allTeamsOn
      requestTypePriorities {
        id
        weight
        requestType{
          id
          name
          active
        }
      }
      config
    }
    totalCount
    pageSize
  }
}`;

const queryGroup = gql`
query GetChannelsGroups {
  channelsGroups {
    id
    name
    description
  }
}`;

function getChannelsPagination(page, pageSize) {
  return Promise.all([
    apollo.client.query({
      query,
      variables: {
        page,
        pageSize,
      },
      fetchPolicy: 'network-only',
    }).then((res) => res.data.channelsPagination)
      .then((data) => ({
        totalCount: data.totalCount,
        pageSizeDefault: data.pageSize,
        channels: data.channels.map((channel) => {
          if (!channel.config || isEmpty(parseConfig(channel.config))) {
            toast.error({
              title: i18n.t('T_ERROR'),
              msg: i18n.t('T_CHANNEL_CONFIGURATION_IS_EMPTY', [channel.name]),
              duration: consts.TOAST_NOTIFICATION_DURATION,
            });
          }
          return ({
            ...channel,
            fields: parseConfig(channel.config),
          });
        }),
      })),
    apollo.client.query({
      query: queryGroup,
      fetchPolicy: 'network-only',
    }).then((res) => res.data.channelsGroups),
  ])
    .then(([{ channels, totalCount, pageSizeDefault }, groups]) => [channels.map((model) => {
      const group = groups[findIndex(groups, { id: model.group.id })];
      return { ...model, group };
    }), totalCount, pageSizeDefault, groups]);
}

export default getChannelsPagination;
